import { isValidTextField, isValidEmail, isValidPhoneField, MAX_CONTACT_NAME_LENGTH, isValidLength } from './validation';
import { IPContact } from 'Order/types/formFields';
import { IContact } from 'Order/types/contact';
import { ISiteContact } from 'Order/types/location';

export const contactIsComplete = (contactDetails: IContact): boolean => {
  return (
    isValidTextField(contactDetails.firstName) &&
    isValidTextField(contactDetails.surname) &&
    isValidLength(contactDetails.firstName + ' ' + contactDetails.surname, MAX_CONTACT_NAME_LENGTH) &&
    isValidPhoneField(contactDetails.phoneNumber) &&
    isValidEmail(contactDetails.email)
  );
};

export const siteContactIsComplete = (siteContact: ISiteContact): boolean => {
  return (
    isValidTextField(siteContact.firstName) &&
    isValidTextField(siteContact.surname) &&
    isValidLength(siteContact.firstName + ' ' + siteContact.surname, MAX_CONTACT_NAME_LENGTH) &&
    isValidPhoneField(siteContact.phone) &&
    isValidEmail(siteContact.email)
  );
};

export const ipContactIsComplete = (ipContact: IPContact): boolean => {
  return (
    isValidTextField(ipContact.address) &&
    isValidEmail(ipContact.email) &&
    isValidTextField(ipContact.firstName) &&
    isValidTextField(ipContact.surname) &&
    isValidLength(ipContact.firstName + ' ' + ipContact.surname, MAX_CONTACT_NAME_LENGTH) &&
    isValidTextField(ipContact.organisation) &&
    isValidPhoneField(ipContact.telephone)
  );
};
